import React, { useState } from 'react';
import { useUser } from '../UserProvider/index';
import './index.css'

const CommentSection = ({ appId, comments }) => {
    const [newComment, setNewComment] = useState('');
    const [allComments, setAllComments] = useState(comments || []);
    const userData = useUser(); 
    
    if (!userData) {
        return <div>Загрузка данных пользователя...</div>;
    }

    const { user } = userData;
    const telegramUserId = localStorage.getItem('telegram_user_id');
    const apiUrl = process.env.REACT_APP_API_URL
    const handleAddComment = async () => {
        if (newComment.trim() === '' || !telegramUserId) return;

        try {
            const response = await fetch(`${apiUrl}apps/${appId}/comments/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: telegramUserId, 
                    text: newComment,
                }),
            });

            if (!response.ok) {
                throw new Error('Failed to post comment');
            }

            const newCommentData = await response.json();
            setAllComments([...allComments, newCommentData]);
            setNewComment('');
        } catch (error) {
            console.error('Error posting comment:', error);
        }
    };

    return (
        <div className="comment-section">

            <div className="comment-input">
                <textarea
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    placeholder="Написать комментарий..."
                />
                <button onClick={handleAddComment}>Добавить комментарий</button>
            </div>
            <ul className="comments-list">
    {allComments.map((comment) => (
        <li key={comment.id} className="comment-item">
            <div className="comment-content">
                <div className="comment-header">
                    <div className="comment-user">{comment.user}</div>
                    <div className="comment-date">
                        {new Date(comment.created_at).toLocaleDateString()} {new Date(comment.created_at).toLocaleTimeString()}
                    </div>
                </div>
                <div className="comment-text">{comment.text}</div>
            </div>
        </li>
    ))}
</ul>

        </div>
    );
};

export default CommentSection;
